<main role="main" aria-labelledby="page-title">
    <h1 id="page-title" [ngClass]="{ 'content-hidden': !locationName }">
        Merry Maids {{ locationName }} <br /><span class="stylized-text">Welcomes You!</span>
    </h1>
    <h2 id="contact-form-title" class="visually-hidden">Contact Information Form</h2>
    <form
        class="contact-form"
        [formGroup]="contactForm"
        (focusout)="onContactFormFocusOut()"
        role="form"
        aria-labelledby="contact-form-title"
    >
        <div class="row">
            <div class="input-holder">
                <label [ngClass]="{ 'invalid-field': isFirstNameInvalid, 'required-error': contactForm.get('firstName')?.invalid && contactForm.get('firstName')?.touched && contactForm.get('firstName')?.errors?.['required'] }" for="firstName">
                    <span class="label required">First Name</span>
                    <input
                        id="firstName"
                        type="text"
                        class="form-control st-input-field"
                        formControlName="firstName"
                        (input)="onNameInput($event)"
                        (focus)="onFieldFocus('firstName')"
                        (blur)="firstNameOnBlur(); onFieldBlur()"
                        maxlength="39"
                        required
                        aria-required="true"
                        [attr.aria-invalid]="isFirstNameInvalid ? 'true' : 'false'"
                        [attr.aria-describedby]="isFirstNameInvalid ? 'firstName-error' : null"
                        [ngClass]="{ 'warning-input': isFirstNameInvalid }"
                    />
                    <span *ngIf="isFirstNameInvalid" id="firstName-error" role="alert">
                        <span
                            class="warning-text"
                            *ngIf="contactForm.controls['firstName']?.hasError('maxlength')"
                            >First name cannot exceed 39 characters.</span
                        >
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('firstName')?.hasError('pattern')"
                            >First name must contain at least one letter.</span
                        >
                    </span>
                </label>
            </div>
            <div class="input-holder">
                <label [ngClass]="{ 'invalid-field': isLastNameInvalid, 'required-error': contactForm.get('lastName')?.invalid && contactForm.get('lastName')?.touched && contactForm.get('lastName')?.errors?.['required'] }" for="lastName">
                    <span class="label required">Last Name</span>
                    <input
                        id="lastName"
                        type="text"
                        class="form-control st-input-field"
                        formControlName="lastName"
                        required
                        aria-required="true"
                        [ngClass]="{ 'warning-input': isLastNameInvalid }"
                        [attr.aria-invalid]="isLastNameInvalid ? 'true' : 'false'"
                        [attr.aria-describedby]="isLastNameInvalid ? 'lastName-error' : null"
                        (input)="onNameInput($event)"
                        (focus)="onFieldFocus('lastName')"
                        (blur)="lastNameOnBlur(); onFieldBlur()"
                        maxlength="39"
                    />
                    <span id="lastName-error" *ngIf="isLastNameInvalid" role="alert">
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('lastName')?.hasError('maxlength')"
                            >Last name cannot exceed 39 characters.</span
                        >
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('lastName')?.hasError('pattern')"
                            >Last name must contain at least one letter.</span
                        >
                    </span>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="input-holder">
                <label [ngClass]="{ 'invalid-field': isEmailInvalid, 'required-error': contactForm.get('email')?.invalid && contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['required'] }" for="email">
                    <span class="label required">Email</span>
                    <input
                        id="email"
                        type="email"
                        class="form-control st-input-field"
                        formControlName="email"
                        required
                        aria-required="true"
                        [attr.aria-invalid]="isEmailInvalid ? 'true' : 'false'"
                        [attr.aria-describedby]="isEmailInvalid ? 'email-error' : null"
                        [ngClass]="{ 'warning-input': isEmailInvalid }"
                        (input)="onEmailInput($event)"
                        (focus)="onFieldFocus('email')"
                        (blur)="emailOnBlur(); onFieldBlur()"
                        maxlength="80"
                    />
                    <span id="email-error" *ngIf="isEmailInvalid" role="alert">
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('email')?.hasError('maxlength')"
                            >Please ensure the email address does not exceed 80 characters.</span
                        >
                        <span
                            class="warning-text"
                            *ngIf="
                                contactForm.get('email')?.hasError('pattern') ||
                                (contactForm.get('email')?.hasError('invalidDomain') &&
                                    contactForm.controls['email'].value)
                            "
                            >Please enter a valid email address.</span
                        >
                    </span>
                </label>
            </div>
            <div class="input-holder">
                <label [ngClass]="{ 'invalid-field': isPhoneInvalid, 'required-error': contactForm.get('phone')?.invalid && contactForm.get('phone')?.touched && contactForm.get('phone')?.errors?.['required'] }" for="phone">
                    <span class="label required">Phone number</span>
                    <input
                        id="phone"
                        type="tel"
                        class="form-control st-input-field"
                        formControlName="phone"
                        required
                        aria-required="true"
                        [attr.aria-invalid]="isPhoneInvalid ? 'true' : 'false'"
                        [attr.aria-describedby]="isPhoneInvalid ? 'phone-error' : null"
                        mask="(000) 000-0000"
                        [dropSpecialCharacters]="true"
                        [showMaskTyped]="true"
                        placeholder="(___) ___-____"
                        [ngClass]="{
                            'warning-input': isPhoneInvalid
                        }"
                        (focus)="onFieldFocus('phone')"
                        (blur)="phoneOnBlur(); onFieldBlur()"
                    />
                    <span id="phone-error" *ngIf="isPhoneInvalid" role="alert">
                        <span
                            class="warning-text"
                            *ngIf="contactForm.get('phone')?.hasError('minlength')"
                            >Please enter a 10-digit phone number.</span
                        >
                        <span
                            class="warning-text"
                            *ngIf="
                                contactForm.get('phone')?.hasError('repeatingDigitsPhone') &&
                                !contactForm.get('phone')?.hasError('minlength') &&
                                !contactForm.get('phone')?.hasError('maxlength')
                            "
                            >Phone number can’t contain all the same digits</span
                        >
                    </span>
                </label>
            </div>
        </div>
        <div class="row">
            <span class="label">Cleaning address</span>
            <div class="address-block">
                <a
                    class="link"
                    gaEvent="edit_address"
                    gaCategory="edit_address"
                    gaLabel="Edit address"
                    [href]="localSiteUrl"
                    aria-label="Edit cleaning address"
                >
                    Edit
                </a>
                <span class="address-text" *ngIf="addressLoaded">{{ address }}</span>
            </div>
        </div>
    </form>
    <div class="tabs-block" role="region" aria-labelledby="levels-heading">
        <h2>
            <span class="stylized-text">To get the most accurate estimate</span> for your cleaning,
            we will collect some important information.
        </h2>
        <h3 id="levels-heading" class="required">How many levels is your home?</h3>
        <app-picker
            [pickerData]="levelsData"
            [selectedValue]="levelsNumber"
            (optionSelected)="onLevelsSelected($event)"
        ></app-picker>
    </div>
    <div class="footage-block" role="region" aria-labelledby="footage-heading">
        <div class="heading">
            <h3 id="footage-heading" class="required">Approximate Square Footage</h3>
        </div>
        <app-slider
            [options]="footageOptions"
            [formattedSliderValue]="footageStringValue"
            [value]="footageDefaultValue"
            (valueChanged)="onFootageValueChanged($event)"
        ></app-slider>
        <div class="footage-limit">
            <div class="btn-holder button-tooltip">
                <button
                    [disabled]="!contactForm.valid"
                    (click)="sendManagerRequest()"
                    class="action-btn"
                    [attr.aria-disabled]="!contactForm.valid ? 'true' : 'false'"
                    aria-label="Submit for homes over 4000 square feet"
                >
                    <img
                        src="/assets/images/star-icon.svg"
                        width="16px"
                        height="16px"
                        alt=""
                        role="presentation"
                    />
                    Over 4,000 sq ft
                </button>
                <span class="tooltip" *ngIf="!contactForm.valid" role="alert"
                    >Please enter your personal data to submit</span
                >
            </div>
            <p>
                If your home is over 4,000 sq ft, we require some additional info for precise
                pricing. Our team will contact you soon!
            </p>
        </div>
        <span class="disabled-text" *ngIf="!contactForm.valid" role="alert"
            >Personal data is required to submit homes over 4000ft²</span
        >
    </div>
    <div class="pets-block" role="region" aria-labelledby="pets-heading">
        <div class="heading">
            <h3 id="pets-heading">
                <span class="stylized-text">We love caring for</span> all of your family!
            </h3>
            <p>How many furry or feathered family members live in your home?</p>
        </div>
        <app-stepper-input
            class="stepper-input"
            [step]="petsStep"
            [min]="petsMinValue"
            [max]="petsMaxValue"
            [initialValue]="petsInitialValue"
            (valueChange)="onPetsValueChange($event)"
            aria-label="Number of pets in your home"
        >
        </app-stepper-input>
    </div>
    <div class="consent-disclaimer">
        <p>By continuing, I give Merry Maids and its franchisees consent to call/text me at my phone number above about my request and other offers (including via automated technology) and to send me marketing and/or promotional messages. Opt out anytime by replying to us with &ldquo;STOP.&rdquo; Message and data rates may apply. I understand that the information I submit may be recorded. Please refer to our <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a [href]="termsOfUseUrl" target="_blank" rel="noopener noreferrer">Terms of Use</a> for additional information.</p>
    </div>
</main>
